/*jslint node: true, browser: true*/

"use strict";

var dateBehaviour = require("pli/forms-knockoutcontrols-date").behaviours.date;
var ko = require("pli/knockout");
var pli = require("pli/forms");
var pliObservable = require("pli/forms-knockoutcontrols");

var dataCache = require("../datacache");
var dependentRequiredBehaviour = require("../ko-behaviours-dependentrequired");
var entityRegistry = require("../entity-registry");
var formattedBehaviour = require("../ko-behaviours-formatted");
var selectionForm = require("../common-selectionform");
var viewModelInit = require("../document/viewModelInitExtensions");


//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// RelatedDoc class
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
function RelatedDoc(factories) {
    /// <summary>
    /// Define viewmodel.
    /// </summary>
    if (window.console && window.console.group) { window.console.log("RelatedDoc.ctor", factories); }

    this.guid = ko.observable(null);
    this.type = pliObservable("ExternalAgreement", dataCache.getObservable("relatedDocType"), "required", "picklist");

    this.agreementDate = pliObservable(null, null, dateBehaviour, formattedBehaviour);
    this.agreementId = pliObservable("", { trigger: this.type, expectedValue: "ExternalAgreement" }, dependentRequiredBehaviour);
    this.agreementType = pliObservable(null, entityRegistry.externalContractType.getPicklistBehaviourData(), "picklist");
    this.description = pliObservable();
    this.fileCreatedBy = ko.observable("");
    this.fileCreatedOn = ko.observable("");
    this.fileKeywords = pliObservable();
    this.fileName = pliObservable();
    this.fileSize = ko.observable();
    this.shortDescription = pliObservable();
    this.fileUploadId = ko.observable(null);
    this.fileStoreId = ko.observable(null);
    this.documentDate = ko.observable(null);
    this.documentType = ko.observable(null);
    this.documentSplitGuid = ko.observable(null);
    this.documentFileNumber = pliObservable();
    this.documentSplitNumber = pliObservable();
    this.documentSplitDescription = ko.observable();

    this.id = ko.computed(this._computeId, this);

    // non-serialized properties
    this.extras = function RelatedDocExtras() { return; };
    this.extras.isLinked = ko.computed(this._computeIsLinked, this);
    this.extras.specificDate = ko.computed(this._computeSpecificDate, this);
    this.extras.specificType = ko.computed(this._computeSpecificType, this);
    this.extras.fileDownloadMessage = ko.observable(null);
    this.extras.uploadMessage = ko.observable(null);
    this.extras.uploadProgress = ko.observable(null);
    this.extras.uploadState = ko.observable(null);
    this.extras.errorsCountFlat = ko.computed(factories.computeErrorsCount, this);
    this.extras.errorsCount = ko.computed(this._computeErrors, this);
    this.extras.icon = ko.computed(this._computeIcon, this);
    this.extras.computedSplitId = pliObservable();
    this.extras.details = ko.computed(this._computeDetails, this);

    ko.computed(this._computeSplitNumber, this);
}


//---------------------------------------
RelatedDoc.prototype.initGridArray = function initRelatedDocGridArray(gridArray) {
    /// <summary>
    /// Add extra methods to the specified
    /// related documents grid array (that has just
    /// been created).
    /// </summary>
    gridArray.attachFiles = RelatedDoc.prototype._attachFiles.bind(gridArray);
    gridArray.linkItems = gridArray.factory.factories.secureAction(RelatedDoc.prototype._linkItems, gridArray);
    gridArray.deleteAndCloseCurrent = gridArray.factory.factories.secureAction(gridArray.deleteAndCloseCurrent, gridArray);
    gridArray.openNew = gridArray.factory.factories.secureAction(gridArray.openNew, gridArray);

    gridArray.openTarget = RelatedDoc.prototype._openTarget.bind(gridArray);
    gridArray.fileDragDropSupported = !!window.FileReader;
    gridArray.copyItems = gridArray.factory.factories.secureAction(RelatedDoc.prototype._copyItems, gridArray);
};


//-------------------------------------------
RelatedDoc.prototype.itemComparer = null; // disable client-side sorting


//-------------------------------------------
RelatedDoc.prototype.loadViewModel = function loadRelatedDoc(record) {
    if (window.console && window.console.group) { window.console.log("RelatedDoc.loadViewModel", record); }

    if (!record) { record = {}; }

    this.type.load(record.type || "ExternalAgreement");

    this.agreementDate.load(record.agreementDate);
    this.agreementId.load(record.agreementId);
    this.agreementType.load(record.agreementType);
    this.description.load(record.description);
    this.documentType(record.documentType || "");
    this.documentDate(record.documentDate || "");
    this.documentFileNumber.load(record.documentFileNumber || "");
    this.documentSplitNumber.load(record.documentSplitNumber || "");
    this.documentSplitGuid(record.documentSplitGuid || null);
    this.documentSplitDescription(record.documentSplitDescription || "");
    this.fileCreatedBy(record.fileCreatedBy || "");
    this.fileCreatedOn(record.fileCreatedOn || "");
    this.fileKeywords.load(record.fileKeywords);
    this.fileName.load(record.fileName);
    this.fileSize(record.fileSize || "");
    this.shortDescription.load(record.shortDescription || record.documentFileNumber);
    this.guid(record.guid || null);
    this.fileUploadId(record.fileUploadId || null);
    this.fileStoreId(record.fileStoreId || null);
};


//-------------------------------------------
RelatedDoc.prototype.updateAttachedFile = function updateRelatedDocFile(state, value) {
    /// <summary>
    /// Updates the state of an attached file.
    /// </summary>
    switch (state) {
    case "done":
        this.fileUploadId(value || null);
        this.extras.uploadProgress(null);
        this.shortDescription.load(this.fileName.peekValue()); // default the title to the same as the file name
        break;
    case "fail":
        this.extras.uploadProgress(null);
        this.extras.uploadMessage(value);
        break;
    default:
        this.extras.uploadProgress(typeof value === "number" ? "".concat(value).concat("%") : null);
        break;
    }
    this.extras.uploadState(state);
};


//-------------------------------------------
RelatedDoc.prototype._attachFiles = function attachRelatedFiles(files) {
    /// <summary>
    /// Attachs uploaded file to the grid view
    /// model of related documents.
    /// </summary>
    /// <remarks>
    /// Expects "this" to be a grid observable
    /// array that creates and stores related documents.
    /// </remarks>
    var i, l, f = [];
    for (i = 0, l = files.length; i < l; i += 1) {
        f[i] = this.createItem({ fileName: files[i].name, type: "UploadedFile" });
        f[i].extras.uploadProgress("0%");
    }
    ko.utils.arrayPushAll(this, f);
    this.valueHasMutated();
    this.sort();
    return f;
};


//-------------------------------------------
RelatedDoc.prototype._computeIcon = function computeIcon() {
    var t = this.type(), errors = this.extras.errorsCount();
    if (errors > 0) { return "sprite-warning-16"; }
    switch (t) {
    case "ContractSplit":
        return "sprite-forms-16";
    case "MineralLeaseSplit":
        return "sprite-mineralLease-16";
    case "SurfaceLeaseSplit":
        return "sprite-surfaceLease-16";
    case "UploadedFile":
        return "sprite-editDocument-16";
    default: // ExternalAgreement
        return "sprite-linkedDoc-16";
    }
};


//-------------------------------------------
RelatedDoc.prototype._computeErrors = function computeRelatedDocErrors() {
    return this.extras.errorsCountFlat()
        + ((this.extras.uploadState() === "fail" || this.extras.uploadState() === "busy") ? 1 : 0);
};


//-------------------------------------------
RelatedDoc.prototype._computeId = function computeRelatedDocId() {
    var value;
    switch (this.type()) {
    case "ContractSplit":
    case "MineralLeaseSplit":
    case "SurfaceLeaseSplit":
        value = this.extras.computedSplitId();
        break;
    case "ExternalAgreement":
        value = this.agreementId();
        break;
    case "UploadedFile":
        value = this.fileName();
        break;
    }
    return value || "";
};


//-------------------------------------------
RelatedDoc.prototype._computeIsLinked = function computeIsLinked() {
    switch (this.type()) {
    case "ContractSplit":
    case "MineralLeaseSplit":
    case "SurfaceLeaseSplit":
        return true;
    default:
        return false;
    }
};


//-------------------------------------------
RelatedDoc.prototype._computeSpecificDate = function computeRelatedDocSpecificDate() {
    var value;
    switch (this.type()) {
    case "ContractSplit":
    case "MineralLeaseSplit":
    case "SurfaceLeaseSplit":
        value = this.documentDate();
        break;
    case "ExternalAgreement":
        value = this.agreementDate.formatted();
        break;
    case "UploadedFile":
        value = this.fileCreatedOn();
        break;
    }
    return value || "";
};


//-------------------------------------------
RelatedDoc.prototype._computeSpecificType = function computeRelatedDocSpecificType() {
    var value;
    switch (this.type()) {
    case "ContractSplit":
    case "MineralLeaseSplit":
    case "SurfaceLeaseSplit":
        value = this.documentType();
        break;
    case "ExternalAgreement":
        value = this.agreementType();
        break;
    case "UploadedFile":
        if (this.extras.uploadState() === "busy") {
            value = "File uploading. Please wait...";
        } else {
            value = "Uploaded file";
        }
        break;
    }
    return value || "";
};


//-------------------------------------------
RelatedDoc.prototype._computeDetails = function computeDetails() {
    var d, s;
    d = this.extras.specificDate();
    s = this.documentSplitDescription();
    return this.extras.specificType() + (d ? " - ".concat(d) : "") + (s ? " - ".concat(s) : "");
};


//-------------------------------------------
RelatedDoc.prototype._computeSplitNumber = function computeSplitNumber() {
    var value = null;
    if (this.extras.isLinked() && this.documentFileNumber() && this.documentSplitNumber()) {
        value = this.documentFileNumber() + " - " + this.documentSplitNumber();
    }
    this.extras.computedSplitId.load(value);
};


//-------------------------------------------
RelatedDoc.prototype._downloadCompleted = function uploadedFileCompleted(response) {
    this.extras.fileDownloadMessage(response.isError ? "File not found" : null);
};


//-------------------------------------------
RelatedDoc.prototype.getNavigationUrl = function getNavigationUrl() {
    return "".concat(
        encodeURIComponent(this.documentFileNumber()),
        "/splits/",
        encodeURIComponent(this.documentSplitNumber())
    );
};


//-------------------------------------------
RelatedDoc.prototype._linkItems = function linkDocs() {
    /// <summary>
    /// Show selection form that allows users
    /// to find and add related documents to this array.
    /// </summary>
    /// <remarks>
    /// Expects "this" to be a grid observable
    /// array that creates and stores related documents.
    /// </remarks>
    selectionForm.open({
        multiSelect: true,
        searchApi: "Geo-Document-SearchRelated",
        text: {
            acceptButton: "Link",
            iconClass: "sprite-link-16",
            examples: [
                "<strong>File Numbers</strong>:<br>C-12 will find C-123, C-1234, etc.<br>M001 will find M001, M0019, etc.",
                "<strong>Areas</strong>:<br>river will find GHOST RIVER, TWO RIVERS, etc.",
                "<strong>Lands</strong>:<br>68 17 4 will find Twp 68-Rge 17-W4M<br>94 h 13 c will find 94-H-11-C<br>Note: Sections are not searched",
                "<strong>Combinations</strong>:<br>C, lloyd will find contracts (starting with C) in the Lloydminster area"
            ],
            title: "Link Documents"
        },
        onAcceptedContext: this,
        onAccepted: function (newDocRows) {
            var currentSplitGuid = this.owner && ko.isObservable(this.owner.guid) && this.owner.guid(),
                rows = !!currentSplitGuid ? ko.utils.arrayFilter(newDocRows, function (item) {
                    return item[6] && item[6].toUpperCase() !== currentSplitGuid.toUpperCase();
                }) : newDocRows;

            selectionForm.utils.pushRowItems({
                targetArray: this,
                records: rows,
                rowMap: { type: 3, documentFileNumber: 4, documentSplitNumber: 5, documentSplitGuid: 6, documentDate: 7, documentType: 8, documentSplitDescription: 9 },
                getIdentity: function (relatedDoc) { return relatedDoc.id(); }
            });
        }
    });
};


//-------------------------------------------
RelatedDoc.prototype._openTarget = function openRelatedDoc() {
    var current = this.current();

    switch (current.type()) {
    case "ContractSplit":
        entityRegistry.contract.open.edit({ url: current.getNavigationUrl() });
        break;
    case "MineralLeaseSplit":
        entityRegistry.mineralLease.open.edit({ url: current.getNavigationUrl() });
        break;
    case "SurfaceLeaseSplit":
        entityRegistry.surfaceLease.open.edit({ url: current.getNavigationUrl() });
        break;
    case "UploadedFile":
        pli.download(current.fileStoreId()).always(current._downloadCompleted.bind(current));
        break;
    }

    return false;
};


//---------------------------------------
RelatedDoc.prototype._copyItems = function copyRelatedDocuments() {
    /// <summary>
    /// Show selection form that allows users
    /// to find and add related documents to this array.
    /// </summary>
    /// <remarks>
    /// Expects "this" to be a grid observable
    /// array that creates and stores related documents.
    /// </remarks>
    selectionForm.open({
        multiSelect: true,
        searchApi: "Geo-Document-SearchRelatedDocuments",
        text: {
            acceptButton: "Copy",
            iconClass: "sprite-link-16",
            examples: [
                "<strong>File Numbers</strong>:<br>C-12 will find C-123, C-1234, etc.<br>M001 will find M001, M0019, etc.",
                "<strong>Areas</strong>:<br>river will find GHOST RIVER, TWO RIVERS, etc.",
                "<strong>Lands</strong>:<br>68 17 4 will find Twp 68-Rge 17-W4M<br>94 h 13 c will find 94-H-11-C<br>Note: Sections are not searched",
                "<strong>Combinations</strong>:<br>C, lloyd will find contracts (starting with C) in the Lloydminster area"
            ],
            title: "Copy Documents"
        },
        onAcceptedContext: this,
        onAccepted: function (newDocRows) {
            // 0 - document ID (File # + " - " + Split ID + " - " + Related Document #)
            // 1 - area
            // 2 - lands
            // 3 - related document formated type
            // 4 - documentType
            // 5 - description
            // Linked documents: documentFileNumber: 6, documentSplitNumber: 7, documentSplitGuid: 8, documentDate: 9, documentType: 10
            // ExternalAgreement: agreementId: 6, agreementType: 7, agreementDate: 8
            // UploadFile: fileName: 6, fileStoreId: 7, fileCreatedOn: 8, fileKeywords: 9

            var i,
                documentsToLink = [],
                externalDocuments = [],
                uploadedFiles = [],
                currentSplitGuid = this.owner && ko.isObservable(this.owner.guid) && this.owner.guid();

            for (i = 0; i < newDocRows.length; i += 1) {
                switch (newDocRows[i][4]) { // related document type
                case "ContractSplit":
                case "MineralLeaseSplit":
                case "SurfaceLeaseSplit":
                    if (!currentSplitGuid || !newDocRows[i][8] || newDocRows[i][8].toUpperCase() !== currentSplitGuid.toUpperCase()) {
                        documentsToLink.push(newDocRows[i]);
                    }
                    break;
                case "ExternalAgreement":
                    externalDocuments.push(newDocRows[i]);
                    break;
                case "UploadedFile":
                    uploadedFiles.push(newDocRows[i]);
                    break;
                }
            }

            // link documents
            if (documentsToLink.length > 0) {
                selectionForm.utils.pushRowItems({
                    targetArray: this,
                    records: documentsToLink,
                    rowMap: { type: 4, description: 5, documentFileNumber: 6, documentSplitNumber: 7, documentSplitGuid: 8, documentDate: 9, documentType: 10, documentSplitDescription: 11 },
                    getIdentity: function (relatedDoc) { return relatedDoc.id(); }
                });
            }

            // add external documents
            if (externalDocuments.length > 0) {
                selectionForm.utils.pushRowItems({
                    targetArray: this,
                    records: externalDocuments,
                    rowMap: { type: 4, description: 5, agreementId: 6, agreementType: 7, agreementDate: 8 }
                });
            }

            // uploaded files
            if (uploadedFiles.length > 0) {
                selectionForm.utils.pushRowItems({
                    targetArray: this,
                    records: uploadedFiles,
                    rowMap: { type: 4, description: 5, fileName: 6, fileStoreId: 7, fileCreatedOn: 8, fileKeywords: 9 }
                });
            }
        }
    });
};


//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Exports
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

module.exports = viewModelInit.standardFactoryCreatorFor(
    RelatedDoc,
    "relatedDocs"
);



//////////////////
// WEBPACK FOOTER
// ./app/document-relateddoc/relatedDocViewModel.js
// module id = 554
// module chunks = 49